
import Vue from "vue";
import { Component } from "vue-property-decorator";
import IconButton from "@/components/UI/IconButton.vue";
import { getFrontendUrl } from "@/lib/document";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import Icon from "@/components/UI/Icon.vue";
import clipboardCopy from "clipboard-copy";
import { documentStore } from "@/store/store";
import { isGlobalBlockType } from "@/lib/constants/post-types";

@Component({
  components: {
    IconButton,
    Dropdown,
    Icon
  }
})
export default class OxygenPreview extends Vue {
  get isGlobalBlock() {
    return isGlobalBlockType(documentStore.document.documentMeta.postType);
  }

  get backToFrontend() {
    return getFrontendUrl();
  }

  copyFrontEndLinkToClipboard() {
    if (this.backToFrontend) {
      clipboardCopy(this.backToFrontend);
    }
  }
}
